import { recordSalesOrderPaymentInputSchema } from '../sales-order/record-payment-input.js';
import { invoiceIdSchema } from './rules.js';
/** An invoice payment is an order payment aimed at one invoice: every field but the target is shared. */
export const recordInvoicePaymentInputSchema = recordSalesOrderPaymentInputSchema
    .omit({ salesOrderId: true })
    .extend({ invoiceId: invoiceIdSchema });
//# sourceMappingURL=record-invoice-payment-input.js.map